var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTireRepair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 16C31 24.2845 24.2845 31 16 31C7.7155 31 1 24.2845 1 16C1 7.7155 7.7155 1 16 1C24.2845 1 31 7.7155 31 16Z",
    stroke: "#2EA36C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.75C18.5859 25.75 21.0658 24.7228 22.8943 22.8943C24.7228 21.0658 25.75 18.5859 25.75 16C25.75 13.4141 24.7228 10.9342 22.8943 9.10571C21.0658 7.27723 18.5859 6.25 16 6.25M16 25.75C13.4141 25.75 10.9342 24.7228 9.10571 22.8943C7.27723 21.0658 6.25 18.5859 6.25 16C6.25 13.4141 7.27723 10.9342 9.10571 9.10571C10.9342 7.27723 13.4141 6.25 16 6.25M16 25.75V18.25M16 6.25V13.75M24.445 11.125L17.95 14.875M14.0515 17.125L7.5565 20.875M24.445 20.875L17.95 17.125M14.0515 14.875L7.5565 11.125",
    stroke: "#2EA36C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 16C18.25 16.5967 18.0129 17.169 17.591 17.591C17.169 18.0129 16.5967 18.25 16 18.25C15.4033 18.25 14.831 18.0129 14.409 17.591C13.9871 17.169 13.75 16.5967 13.75 16C13.75 15.4033 13.9871 14.831 14.409 14.409C14.831 13.9871 15.4033 13.75 16 13.75C16.5967 13.75 17.169 13.9871 17.591 14.409C18.0129 14.831 18.25 15.4033 18.25 16Z",
    stroke: "#2EA36C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTireRepair);
export default __webpack_public_path__ + "static/media/tire-repair.1ddfeed3472232a966b1f88bec9fb253.svg";
export { ForwardRef as ReactComponent };